import {
	Home,
	Megaphone,
	ShoppingCart2,
	UserCircle,
	Users,
} from "@layer/icons";
import type { AppRouteType } from "@layer/utils/lib/routing";

export const routes: AppRouteType[] = [
	{
		name: "Home",
		href: "/",
		hidden: true,
		icon: Home,
	},
	{
		name: "Campaigns",
		href: "/campaigns",
		hidden: false,
		icon: Megaphone,
	},
	{
		name: "Cohorts",
		href: "/cohorts",
		hidden: false,
		icon: Users,
	},
	{
		name: "Merchants",
		href: "/merchants",
		hidden: false,
		icon: ShoppingCart2,
	},
	{
		name: "Client Profile",
		href: "/client-profile",
		hidden: false,
		icon: UserCircle,
	},
] as const;
